import type { NexusRelation } from "../../domain/mesh";

export type RelationPhysics = {
  bendScale: number;
  skewScale: number;
  liftScale: number;
  opacityScale: number;
  activityHz: number;
  activityDepth: number;
  hue: string;
};

export const relationPhysics: Record<NexusRelation, RelationPhysics> = {
  depends_on: {
    bendScale: 1.12,
    skewScale: 0.8,
    liftScale: 1.24,
    opacityScale: 0.9,
    activityHz: 0.18,
    activityDepth: 0.12,
    hue: "#a8c7ff",
  },
  presents: {
    bendScale: 0.84,
    skewScale: 0.72,
    liftScale: 0.78,
    opacityScale: 0.82,
    activityHz: 0.1,
    activityDepth: 0.08,
    hue: "#e6edf8",
  },
  tracks: {
    bendScale: 1.26,
    skewScale: 1.18,
    liftScale: 1.04,
    opacityScale: 0.82,
    activityHz: 0.34,
    activityDepth: 0.15,
    hue: "#c8dcff",
  },
  contains: {
    bendScale: 0.68,
    skewScale: 0.52,
    liftScale: 0.7,
    opacityScale: 0.72,
    activityHz: 0.08,
    activityDepth: 0.06,
    hue: "#b8c8da",
  },
  relates_to: {
    bendScale: 1.42,
    skewScale: 1.36,
    liftScale: 1.14,
    opacityScale: 0.68,
    activityHz: 0.22,
    activityDepth: 0.13,
    hue: "#bac7d8",
  },
  drives: {
    bendScale: 1.08,
    skewScale: 0.92,
    liftScale: 1.34,
    opacityScale: 0.94,
    activityHz: 0.28,
    activityDepth: 0.16,
    hue: "#f1dfc4",
  },
  located_at: {
    bendScale: 0.76,
    skewScale: 0.42,
    liftScale: 0.62,
    opacityScale: 0.78,
    activityHz: 0.06,
    activityDepth: 0.05,
    hue: "#c9d8cf",
  },
};

export function relationPhase(id: string) {
  let hash = 2166136261;
  for (let index = 0; index < id.length; index += 1) {
    hash ^= id.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (Math.abs(hash) % 6283) / 1000;
}
